import { WbsListDto } from '@api/client';
import { createReducer } from '@reduxjs/toolkit';
import { getWbsProjectPlanningById, saveWbsDataTable, saveWbsPlanning } from './actions';

interface InitialState {
  wbsData: WbsListDto[] | undefined;
  wbsDataTable: WbsListDto[] | undefined;
}

const initialState: InitialState = {
  wbsData: undefined,
  wbsDataTable: undefined,
};

export const planningControllerReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getWbsProjectPlanningById.fulfilled, (state, action) => {
      state.wbsData = action.payload;
    })
    .addCase(saveWbsPlanning.fulfilled, (state, action) => {
      state.wbsData = action.payload;
    })
    .addCase(saveWbsDataTable, (state, action) => {
      state.wbsDataTable = action.payload;
    });
});
